<template>
  <v-container
    id="contas-pagar-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <dashboard-filtro-datas
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :url="link"
          />
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Valores a Pagar
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('215')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <br><br>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-row v-if="loading">
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <div
                            :style="styleObject"
                            class="text-center"
                          >
                            <v-icon
                              light
                              class="custom-loader"
                              :style="styleObject"
                            >
                              mdi-cached
                            </v-icon>
                            Carregando dados...
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="error">
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <div
                            class="alert alert-danger"
                          >
                            {{ error }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col
                          id="valorPagarId"
                          cols="12"
                          sm="9"
                          md="9"
                          lg="9"
                          class="text-right"
                          :style="styleObject"
                        >
                          {{ valorPagar }}
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          md="2"
                          lg="2"
                          class="text-right"
                        >
                          <router-link
                            to="/contas-pagar/valor-a-pagar"
                            :style="styleObject"
                          >
                            <v-icon
                              id="iconLinkDetalheAPagar"
                              class="text-left"
                            >
                              mdi-dots-vertical
                            </v-icon>
                          </router-link>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Valores Pagos
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('216')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-valor-pago id="valorPagoId" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Valores em aberto
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('217')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-valor-vencer id="valorPagarAbertoId" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Valores Vencidos
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('218')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-valor-vencido id="valorPagarVencidoId" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              id="valorJurosPagamento"
              cols="12"
              sm="12"
              md="6"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'219'"
                :text="'Juros Pagos'"
                :texto-information="textoJurosPagos"
                :style-object="styleObject"
                :componente-valor="true"
                :valor="valorJurosPagos"
                :padding="dynamicPaddingContasPagar2"
                :width="width"
                :loading="loadingJurosPagos"
              />
            </v-col>
            <v-col
              id="valorDescontoPagamento"
              cols="12"
              sm="12"
              md="6"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'220'"
                :text="'Descontos Obtidos'"
                :texto-information="textoDescontosObtidos"
                :style-object="styleObject"
                :componente-valor="true"
                :valor="valorDescontoPagar"
                :padding="dynamicPaddingContasPagar2"
                :width="width"
                :loading="loadingDescontoPagar"
              />
            </v-col>
            <v-col
              id="prazoMedioCompra"
              cols="12"
              sm="12"
              md="6"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'221'"
                :text="'Prazo Médio de Compras (PMC)'"
                :texto-information="textoPMC"
                :style-object="styleObject"
                :componente-valor="true"
                :valor="`${valorPMC} dias`"
                :padding="dynamicPaddingContasPagar2"
                :width="width"
                :loading="loadingPMC"
              />
            </v-col>
            <v-col
              id="prazoMedioPagamento"
              cols="12"
              sm="12"
              md="6"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'222'"
                :text="'Prazo Médio Pagamento (PMP)'"
                :texto-information="textoPMP"
                :style-object="styleObject"
                :componente-valor="true"
                :valor="`${valorPMP} dias`"
                :padding="dynamicPaddingContasPagar2"
                :width="width"
                :loading="loadingPMP"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              id="componenteContasPagar"
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'223'"
                :text="'Projeção de contas a pagar diárias'"
                :texto-information="textoPagarDiario"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChart29'"
                :dados-grafico="chartProjecaoContasPagar"
                :titulo-id="'myChart29'"
                :legenda-grafico="corProjecaoContasPagar"
                :exibir-legenda="true"
                :padding="dynamicPaddingContasPagar3"
                :width="widthProjecao"
                :loading="loadingProjecaoContasPagar"
              />
            </v-col>
            <v-col
              id="componenteContasPagar"
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Ranking de Fornecedores dos Período
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('224')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-dados-fornecedores-contas-pagar />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              id="componenteContasPagar"
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'225'"
                :text="'Como está nossa contas a pagar por tipo de conta?'"
                :texto-information="textoContasPagar"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChart30'"
                :dados-grafico="chartContasPagar"
                :titulo-id="'myChart30'"
                :legenda-grafico="legendaContasPagar"
                :exibir-legenda="true"
                :padding="dynamicPaddingContasPagar5"
                :width="widthProjecao"
                :loading="loadingContasPagar"
              />
            </v-col>
            <v-col
              id="componenteContasPagar"
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'226'"
                :text="'Discriminação dos tipos de contas'"
                :texto-information="textoDiscriminacaoPagar"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChart31'"
                :dados-grafico="chartContasPagarAberto"
                :titulo-id="'myChart31'"
                :legenda-grafico="legendaContasPagarAberto"
                :exibir-legenda="true"
                :padding="dynamicPaddingContasPagar6"
                :width="widthProjecao"
                :loading="loadingContasPagarAberto"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              id="componenteContasPagar"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
                :max-width="width"
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Evolução dos contas a pagar para ano.
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('227')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        v-if="loadingContasPagarAnual"
                        id="carregaDados"
                        class="text-center"
                        :style="styleObject"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando Dados...
                      </div>
                      <div
                        v-else-if="error"
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                      <canvas
                        id="myChart32"
                        width="180"
                        height="70"
                      />
                      <br>
                      <div
                        v-if="exibirLegenda"
                        id="legendaDistribuicaoCliente"
                        class="text-center px-3"
                      >
                        <v-row
                          align="center"
                          class="ma-0"
                          no-gutters
                        >
                          <v-col
                            md="12"
                            offset-md="1"
                          >
                            <v-row>
                              <div
                                v-for="status in legendaContasPagarAnual"
                                :key="status.status"
                              >
                                <v-avatar
                                  class="mr-1"
                                  :color="status.cor"
                                  size="12"
                                />
                                <span class="mr-3 font-weight-light">{{ status.status }}</span>
                              </div>
                            </v-row>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import ContasPagar from '../../../../services/contaspagar'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  const pluginTextContasPagar = {
    id: 'centerText',
    beforeDraw (chart) {
      const centerConfig = chart.config.options.elements?.center
      if (!centerConfig) return

      const ctx = chart.chart.ctx
      const txt = centerConfig.text
      const fontStyle = centerConfig.fontStyle || 'Arial'
      const color = centerConfig.color || '#000'

      const width = chart.chartArea.right - chart.chartArea.left
      const height = chart.chartArea.bottom - chart.chartArea.top

      const fontSize = Math.min(width, height) / 3.5

      ctx.save()
      ctx.font = `${fontStyle} ${fontSize}px Arial`
      ctx.fillStyle = color
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'

      const centerX =
        (chart.chartArea.left + chart.chartArea.right) / 2
      const centerY =
        (chart.chartArea.top + chart.chartArea.bottom + 30) / 2

      ctx.fillText(txt, centerX, centerY)
      ctx.restore()
    },
  }

  export default {
    name: 'DashboardContasReceber',
    emits: ['setValoresPagos', 'setValoresPagarVencer', 'setValoresPagarVencidos', 'setDadosFiltro', 'setvaloresprazomedioponderado', 'setValoresDescontoJuros', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashoardCardView: () => import('../../components/core/CardView'),
      DashboardValorPago: () => import('../../graficos/ContasPagar/ValorPago'),
      DashboardValorVencer: () => import('../../graficos/ContasPagar/ValorVencer'),
      DashboardValorVencido: () => import('../../graficos/ContasPagar/ValorVencido'),
      ShowDadosFornecedoresContasPagar: () => import('../../components/financeiro/contasPagar/ContasPagarDadosFornecedores'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectInadimplente: {
        color: '#f27686',
      },
      styleObjectClientesInadimplentes: {
        color: '#757575',
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      link: window.location.href,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      valorPagar: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagarEnviar: 0,
      loading: false,
      error: null,
      codigo: 0,
      orientacao: [],
      textoVlrPagar: '',
      textoVlrPago: '',
      textoVlrAberto: '',
      textoVlrVencimento: '',
      textoJurosPagos: '',
      textoDescontosObtidos: '',
      textoPMC: '',
      textoPMP: '',
      textoPagarDiario: '',
      textoPagarFornecedores: '',
      textoContasPagar: '',
      textoDiscriminacaoPagar: '',
      textoContasPagarAnual: '',
      codigoIds: ['215', '216', '217', '218', '219', '220', '221', '222', '223', '224', '225', '226', '227'],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      valorJurosPagos: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDescontoPagar: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPMC: parseFloat(0),
      valorPMP: parseFloat(0),
      chartProjecaoContasPagar: {},
      corProjecaoContasPagar: [],
      chartContasPagar: {},
      legendaContasPagar: [],
      corContasPagar: [],
      chartContasPagarAberto: {},
      legendaContasPagarAberto: [],
      chartContasPagarAnual: {},
      legendaContasPagarAnual: [],
      dynamicPaddingContasPagar1: '',
      dynamicPaddingContasPagar2: '',
      dynamicPaddingContasPagar3: '',
      dynamicPaddingContasPagar4: '',
      dynamicPaddingContasPagar5: '',
      dynamicPaddingContasPagar6: '',
      dynamicPaddingContasPagar7: '',
      with: '',
      widthProjecao: '',
      widthEvolucaoAnual: '',
      loadingJurosPagos: false,
      loadingDescontoPagar: false,
      loadingPMC: false,
      loadingPMP: false,
      loadingProjecaoContasPagar: false,
      loadingContasPagar: false,
      loadingContasPagarAberto: false,
      loadingContasPagarAnual: false,
      exibirLegenda: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)

      Chart.plugins.unregister(pluginTextContasPagar)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        Chart.plugins.register(pluginTextContasPagar)

        eventEmit.$emit('atualizar_texto', 'Contas Pagar')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingContasPagar1 = 'padding-right: 10.4rem !important'

          this.dynamicPaddingContasPagar2 = 'padding-right: 10.4rem !important'

          this.dynamicPaddingContasPagar3 = 'padding-right: 43rem !important'

          this.dynamicPaddingContasPagar4 = 'padding-right: 43rem !important'

          this.dynamicPaddingContasPagar5 = 'padding-right: 37rem !important'

          this.dynamicPaddingContasPagar6 = 'padding-right: 43rem !important'

          this.dynamicPaddingContasPagar7 = 'padding-right: 102rem !important'

          this.width = ''

          this.widthProjecao = ''

          this.widthEvolucaoAnual = ''
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingContasPagar1 = 'padding-right: 2rem !important'

          this.dynamicPaddingContasPagar2 = 'padding-right: 2rem !important'

          this.dynamicPaddingContasPagar3 = 'padding-right: 17rem !important'

          this.dynamicPaddingContasPagar4 = 'padding-right: 17rem !important'

          this.dynamicPaddingContasPagar5 = 'padding-right: 17rem !important'

          this.dynamicPaddingContasPagar6 = 'padding-right: 17rem !important'

          this.dynamicPaddingContasPagar7 = 'padding-right: 63.5rem !important'

          this.width = ''

          this.widthProjecao = ''

          this.widthEvolucaoAnual = ''
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingContasPagar1 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasPagar2 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasPagar3 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasPagar4 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasPagar5 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasPagar6 = 'padding-right: 11rem !important'

          this.dynamicPaddingContasPagar7 = 'padding-right: 11rem !important'

          this.width = '410'

          this.widthProjecao = '410'

          this.widthEvolucaoAnual = '410'
        } else if (window.innerWidth > 600 && window.innerWidth < 1000) {
          this.dynamicPaddingContasPagar1 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasPagar2 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasPagar3 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasPagar4 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasPagar5 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasPagar6 = 'padding-right: 25rem !important'

          this.dynamicPaddingContasPagar7 = 'padding-right: 25rem !important'

          this.width = ''

          this.widthProjecao = ''

          this.widthEvolucaoAnual = ''
        } else {
          this.dynamicPaddingContasPagar1 = 'padding-right: 2rem !important'

          this.dynamicPaddingContasPagar2 = 'padding-right: 2rem !important'

          this.dynamicPaddingContasPagar3 = 'padding-right: 15rem !important'

          this.dynamicPaddingContasPagar4 = 'padding-right: 15rem !important'

          this.dynamicPaddingContasPagar5 = 'padding-right: 15rem !important'

          this.dynamicPaddingContasPagar6 = 'padding-right: 15rem !important'

          this.dynamicPaddingContasPagar7 = 'padding-right: 57.8rem !important'

          this.width = ''

          this.widthProjecao = ''

          this.widthEvolucaoAnual = ''
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select

        this.updateDate()
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async updateDate () {
        this.valorPagar = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagarEnviar = parseFloat(0)
        this.valorJurosPagos = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDescontoPagar = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPMC = parseFloat(0)
        this.valorPMP = parseFloat(0)
        this.exibirLegenda = false

        if (this.chartProjecaoContasPagar.data) {
          this.chartProjecaoContasPagar.destroy()

          this.corProjecaoContasPagar = []
        }

        if (this.chartContasPagar.data) {
          this.legendaContasPagar = []
          this.corContasPagar = []
          this.chartContasPagar.destroy()
        }

        if (this.chartContasPagarAberto.data) {
          this.chartContasPagarAberto.destroy()
          this.legendaContasPagarAberto = []
        }

        if (this.chartContasPagarAnual.data) {
          this.chartContasPagarAnual.destroy()

          this.legendaContasPagarAnual = []
        }

        this.loadingJurosPagos = true
        this.loadingDescontoPagar = true
        this.loadingPMC = true
        this.loadingPMP = true
        this.loadingProjecaoContasPagar = true
        this.loadingContasPagar = true
        this.loadingContasPagarAberto = true
        this.loadingContasPagarAnual = true

        this.showContasPagarValoresAPagar()

        eventEmit.$emit('set-dados-filtro', this.primeiroDia, this.ultimoDia, this.select)
        eventEmit.$emit('set-valores-pagos', this.primeiroDia, this.ultimoDia, this.select)
        eventEmit.$emit('set-valores-pagar-vencer', this.primeiroDia, this.ultimoDia, this.select)
        eventEmit.$emit('set-valores-pagar-vencidos', this.primeiroDia, this.ultimoDia, this.select)
        eventEmit.$emit('set-valores-prazo-medio-ponderado', this.primeiroDia, this.ultimoDia, this.select)
        eventEmit.$emit('set-valores-desconto-juros', this.primeiroDia, this.ultimoDia, this.select)

        await ContasPagar.showJurosPagar(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorJurosPagos = resposta.data.jurosPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorJurosPagos = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingJurosPagos = false })

        await ContasPagar.showDescontoPagar(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorDescontoPagar = resposta.data.desconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorDescontoPagar = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDescontoPagar = false })

        await ContasPagar.showPMC(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorPMC = resposta.data.prazoMedio
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorPMC = parseFloat(0)

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingPMC = false })

        await ContasPagar.showPMP(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorPMP = resposta.data.prazoMedio
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorPMP = parseFloat(0)

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingPMP = false })

        await ContasPagar.showProjecaoContasPagar(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.corProjecaoContasPagar = resposta.data.legenda

            const ctx = document.getElementById('myChart29').getContext('2d')
            this.chartProjecaoContasPagar = new Chart(ctx, {
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Valor Pago',
                    data: resposta.data.pago,
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Valor Aberto',
                    data: resposta.data.aberto,
                    backgroundColor: '#43A047',
                    order: 2,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] > 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return null
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há valores a pagar a vencer no período selecionado') {
            this.text = resposta.data.mg

            if (this.chartProjecaoContasPagar.data) {
              this.chartProjecaoContasPagar.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Não datas de vencimento de valores a pagar no período selecionado') {
            this.text = resposta.data.mg

            if (this.chartProjecaoContasPagar.data) {
              this.chartProjecaoContasPagar.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoContasPagar = false })

        await ContasPagar.showContasPagar(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.legendaContasPagar = resposta.data.cores

            for (var i = 0; i < resposta.data.cores.length; i++) {
              const cor = resposta.data.cores[i].cor

              this.corContasPagar.push(cor)
            }

            const ctx = document.getElementById('myChart30').getContext('2d')
            this.chartContasPagar = new Chart(ctx, {
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Saldo',
                    data: resposta.data.dadosContas,
                    backgroundColor: this.corContasPagar,
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há valores a pagar a vencer no período selecionado') {
            this.text = resposta.data.mg

            if (this.chartContasPagar.data) {
              this.legendaContasPagar = []
              this.corContasPagar = []
              this.chartContasPagar.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Não datas de vencimento de valores a pagar no período selecionado') {
            this.text = resposta.data.mg

            if (this.chartContasPagar.data) {
              this.legendaContasPagar = []
              this.corContasPagar = []
              this.chartContasPagar.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingContasPagar = false })

        await ContasPagar.showContasAberta(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.legendaContasPagarAberto = resposta.data.legenda

            const ctx = document.getElementById('myChart31').getContext('2d')
            this.chartContasPagarAberto = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Saldo',
                    data: resposta.data.dadosAberto,
                    backgroundColor: '#4CAF50',
                    order: 2,
                  },
                  {
                    label: 'Valor Pago',
                    data: resposta.data.dadosPago,
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Valor Vencimento',
                    data: resposta.data.dadosVencido,
                    backgroundColor: '#E53935',
                    order: 3,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      return '#FFFFFF'
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      if (value > parseFloat(0)) {
                        return value.toFixed(2) + '%'
                      } else {
                        return ''
                      }
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      for (let i = 0; i < resposta.data.dadosContas.length; i++) {
                        if (resposta.data.dadosContas[i].status === tooltipItem.yLabel) {
                          if (tooltipItem.xLabel > parseFloat(0)) {
                            var valor = resposta.data.dadosContas[i].valor * (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / 100)

                            return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                          } else {
                            return null
                          }
                        }
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há valores a pagar a vencer no período selecionado') {
            this.text = resposta.data.mg

            if (this.chartContasPagarAberto.data) {
              this.chartContasPagarAberto.destroy()
              this.legendaContasPagarAberto = []
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Não datas de vencimento de valores a pagar no período selecionado') {
            this.text = resposta.data.mg

            if (this.chartContasPagarAberto.data) {
              this.chartContasPagarAberto.destroy()
              this.legendaContasPagarAberto = []
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingContasPagarAberto = false })

        await ContasPagar.showContasAPagarAnual(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.legendaContasPagarAnual = resposta.data.legenda

            const ctx = document.getElementById('myChart32').getContext('2d')
            this.chartContasPagarAnual = new Chart(ctx, {
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Saldo',
                    data: resposta.data.dadosAberto,
                    backgroundColor: '#4CAF50',
                    order: 2,
                  },
                  {
                    label: 'Valor Pago',
                    data: resposta.data.dadosPago,
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Valor Vencimento',
                    data: resposta.data.dadosVencido,
                    backgroundColor: '#E53935',
                    order: 3,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] > 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return null
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há valores a pagar a vencer no período selecionado') {
            this.text = resposta.data.mg

            if (this.chartContasPagarAnual.data) {
              this.chartContasPagarAnual.destroy()

              this.legendaContasPagarAnual = []
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Não datas de vencimento de valores a pagar no período selecionado') {
            this.text = resposta.data.mg

            if (this.chartContasPagarAnual.data) {
              this.chartContasPagarAnual.destroy()

              this.legendaContasPagarAnual = []
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingContasPagarAnual = false

          this.exibirLegenda = true
        })
      },

      async showContasPagarValoresAPagar () {
        this.loading = true

        await ContasPagar.showValoresAPagar(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorPagar = resposta.data.valorPagar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorPagarEnviar = resposta.data.valorPagar
          } else if (resposta.data.msg === 'Não há valores a pagar no período selecionado') {
            this.valorPagar = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorPagarEnviar = 0

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    /* #valoresPagar {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 0 -7rem;
    } */

    #iconInformationValorPagar {
      margin: 0rem 0 0 6rem;
    }

    #valorPagarId {
      margin: -2rem 5rem 0 -2rem !important;
      font-weight: bold;
    }

    #iconLinkDetalheAPagar {
      margin: -6.85rem 0 0 -2rem;
    }

    /* #valoresPagos {
      font-size: 14px;
      font-weight: bold;
      margin: -1.5rem 0 0 -7.2rem;
    } */

    #iconInformationValoresPagos {
      margin: -3.2rem 0 0 6.2rem;
    }

    /* #valoresAVencer {
      font-size: 14px;
      font-weight: bold;
      margin: -2.5rem 0 0 -6.4rem;
    } */

    #iconInformationValorAVencer {
      margin: -5.2rem 0 0 5.5rem;
    }

    /* #valoresVencido {
      font-size: 14px;
      font-weight: bold;
      margin: -2.5rem 0 0 -6.4rem;
    } */

    #iconInformationValorPagarVencido {
      margin: -5.2rem 0 0 5.5rem;
    }

    #iconInformationPagarDiario {
      margin: 0 0 0 -1.2rem
    }

    #iconInformationPagarMesAMes {
      margin: 0 0 0 -1.2rem
    }

    #iconInformationRankingFornecedores {
      margin: 0 0 0 -1.2rem
    }

    /* #valorJurosPagamento {
      margin: 0 0 0 2rem
    } */

    #iconInformationJurosPagos {
      margin: 0 0 0 -3rem
    }

    /* #valorDescontoPagamento {
      margin: 0 0 0 2rem
    } */

    #iconInformationDescontoRecebido {
      margin: 0 0 0 -3rem
    }

    /* #prazoMedioCompra {
      margin: 0 0 0 2rem
    } */

    #iconInformationPMC {
      margin: 0 0 0 -3rem
    }

    /* #prazoMedioPagamento {
      margin: 0 0 0 2rem
    } */

    #iconInformationPMP {
      margin: 0 0 0 -3rem
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    /* #valoresPagar {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 0 -19rem;
    } */

    #iconInformationValorPagar {
      margin: 0rem 0 0 -8rem;
    }

    /* #valorPagarId {
      font-size: 22px;
      display: grid;
      align-items: center;
      margin: -0.5rem 5rem 0 12.5rem;
      font-weight: bold;
    } */

    #iconLinkDetalheAPagar {
      margin: -0.2rem 0 0 1.5rem;
    }

    /* #valoresPagos {
      font-size: 14px;
      font-weight: bold;
      margin: -5.1rem 0 0 7.8rem;
    } */

    /* #valoresAVencer {
      font-size: 14px;
      font-weight: bold;
      margin: -2rem 0 0 -18.5rem;
    } */

    #iconInformationValorPagos {
      margin: -3.7rem 0 0 4rem;
    }

    #iconLinkDetalhePago {
      margin: -4rem 0 0 33rem
    }

    #iconInformationValoresPagos {
      margin: -10.2rem 0 0 58.8rem;
    }

    #iconInformationValorAVencer {
      margin: -4rem 0 0 -8.5rem;
    }

    #iconLinkPagarVencido {
      margin: -4rem 0 0 33rem
    }

    /* #valoresVencido {
      font-size: 14px;
      font-weight: bold;
      margin: -9.4rem 0 0 8.5rem;
    } */

    #iconInformationValorPagarVencido {
      margin: -18.8rem 0 0 58.8rem;
    }

    #bloco1CP {
      margin: -5rem 0 0 0;
    }

    #iconInformationPagarDiario {
      margin: 0 0 0 1.6rem
    }

    #iconInformationPagarMesAMes {
      margin: 0 0 0 1.6rem
    }

    #iconInformationRankingFornecedores {
      margin: 0 0 0 1.6rem
    }

    /* #valorJurosPagamento {
      margin: 0 0 0 2rem
    } */

    #iconInformationJurosPagos {
      margin: 0 0 0 -5rem
    }

    /* #valorDescontoPagamento {
      margin: 0 0 0 -2.5rem
    } */

    #iconInformationDescontoRecebido {
      margin: 0 0 0 -2.7rem
    }

    /* #prazoMedioCompra {
      margin: 0 0 0 -1rem
    } */

    #iconInformationPMC {
      margin: 0 0 0 -2rem
    }
    /* #prazoMedioPagamento {
      margin: 0 0 0 1rem
    } */

    #iconInformationPMP {
      margin: 0 0 0 -0.5rem
    }
  }

  @media screen and (min-width: 1380px) and (max-width: 1650px) {
    #valorPagarId {
      margin: -2rem 0 2rem 1rem;
    }

    #iconLinkDetalheAPagar {
      margin: -4rem 0 0 -2rem;
    }

    #valorPagoId {
      margin: 0 0 0rem 0rem
    }

    #valorPagarAbertoId {
      margin: 0 0 -2rem 0rem
    }

    #valorPagarVencidoId {
      margin: 0 0 -2rem 0rem
    }
  }

  @media screen
  and (min-width: 1651px) {
    #valorPagarId {
      margin: -1.5rem 0 2.2rem 2rem;
    }

    #iconLinkDetalheAPagar {
      margin: -3rem 0 0 -1rem;
    }

    #valorPagoId {
      margin: 0 0 0rem 0rem
    }

    #valorPagarAbertoId {
      margin: 0 0 0rem 0rem
    }

    #valorPagarVencidoId {
      margin: 0 0 0rem 0rem
    }
  }
</style>

<style lang="sass">
  #bloco1
    margin-left: -5rem

  #valoresPagar
    font-size: 14px
    font-weight: bold

  #valoresPagos
    font-size: 14px
    font-weight: bold
    margin: 0 0 0 -4rem

  #valorPagarId
    font-size: 20px
    display: grid
    align-items: center
    margin: -3.5rem 0 0 0.7rem
    font-weight: bold

  #iconInformationValoresPagos
    margin-left: 3rem

  #iconInformationValorAVencer
    margin: 0 0 0 3rem

  #iconInformationValorPagarVencido
    margin-left: 3rem

  #valorInadimplenciaId
    font-size: 24px
    display: grid
    align-items: center
    margin: -0.1rem 5rem 0 8.5rem
    font-weight: bold

  #valorClientesInadimplentesId
    font-size: 24px
    display: grid
    align-items: center
    margin: -0.1rem 5rem 0 8.5rem
    font-weight: bold

  #valorTituloVencidosId
    font-size: 18px
    display: grid
    align-items: center
    margin: -0.1rem 5rem 0 8.5rem
    font-weight: bold

  #tituloVencidoVinteDias
    margin: 0 0 0 1rem

  #iconLinkDetalheAPagar
    margin: -4rem 0 0 0.7rem

  #iconLinkDetalhePago
    margin: -4rem 0 0 9rem

  #iconLinkDetalheAberto
    margin: -4rem 0 0 8rem

  #iconLinkDetalheVencido
    margin: -4rem 0 0 7rem

  #iconLinkDetalheInadimplencia
    margin: -4rem 0 0 19.6rem

  #linkDetalheFornecedores
    color: black

  #iconLinkPagarVencido
    margin: -4rem 0 0 9rem

  .container
    max-width: 100%

  #valoresAVencer
    margin: 0 0 0 -5.5rem
    font-weight: bold

  #valoresVencido
    margin: 0 0 0 -5.5rem
    font-weight: bold

  #iconInformationValorPagarVencido
    margin: 0 0 0 4.5rem

  #iconInformationPagarDiario
    margin: 0 0 0 -1.35rem

  #iconInformationPagarMesAMes
    margin: 0 0 0 4.5rem

  #iconInformationRankingFornecedores
    margin: 0 0 0 0.8rem

  #iconInformationDescontoRecebido
    margin: 0 0 0 1rem

  #valorJurosPagamento
    margin: -2rem 0 0 0rem
    // font-size: 14px
    font-weight: bold

  #iconInformationJurosPagos
    margin: 0 0 0 -5rem

  #valorDescontoPagamento
    margin: -2rem 0 0 0rem
    font-size: 14px
    font-weight: bold

  #iconInformationDescontoRecebido
    margin: 0 0 0 -2.7rem

  #prazoMedioCompra
    margin: -2rem 0 0 0rem
    font-size: 14px
    font-weight: bold

  #iconInformationPMC
    margin: 0 0 0 -2rem

  #prazoMedioPagamento
    margin: -2rem 0 0 0
    font-size: 14px
    font-weight: bold

  #iconInformationPMP
    margin: 0 0 0 -0.5rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemContasPagar
    margin: -2rem 0 0 -1rem

  #listItemContasPagarFornecedores
    margin: -2rem 0 0 -1rem

  #componenteContasPagar
    margin: -2rem 0 0 0rem

  #valorPagoId
    margin: 0 0 -2rem 0rem

  #valorPagarAbertoId
    margin: 0 0 -2.5rem 0rem

  #valorPagarVencidoId
    margin: 0 0 -2.5rem 0rem

</style>
